import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/UserContext';
import { defaultStatusValue } from 'utilities/fns';

function useStatus() {
  const [status, handleStatus] = useState('');
  const { userInfo = {} } = useContext(UserContext);

  useEffect(() => {
    const _status = defaultStatusValue({ role: userInfo?.data?.key });
    handleStatus(_status);
  }, [userInfo?.data?.key]);

  return [status, handleStatus];
}

export default useStatus;
